<button (click)="downloadFile($event)" class="w-full max-w-md">
  <div
    class="overflow-hidden justify-between bg-base-100 rounded-lg w-full text-sm text-base-content cursor-pointer flex gap-4 items-center border border-base-content/20 p-4 hover:border-primary hover:bg-primary/5 transition-all">
    <div class="flex gap-3 items-center flex-1 min-w-0">
      <div class="size-10 bg-primary/10 rounded-lg flex items-center justify-center shrink-0">
        @if (isLoading()) {
          <span class="icon-[line-md--downloading-loop] size-5 text-primary"></span>
        } @else {
          <span class="icon-[mdi--file-document-outline] size-5 text-primary"></span>
        }
      </div>
      <p class="truncate font-medium">{{ filename() }}</p>
    </div>
    <div class="flex items-center gap-3 shrink-0">
      @if (displaySize() > 0) {
        <span class="text-base-content/60 text-xs">{{ fileSizeFormat(displaySize()) }}</span>
      }
      <div
        class="size-8 bg-base-200 rounded-lg flex items-center justify-center hover:bg-primary hover:text-white transition-all">
        @if (isLoading()) {
          <span class="icon-[line-md--downloading-loop] size-4"></span>
        } @else {
          <span class="icon-[mdi--download] size-4"></span>
        }
      </div>
    </div>
  </div>
</button>
